
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`HIPAA compliance`}</h1>
    <p>{`We are now offering HIPAA-compliant BAAs.
Becoming HIPAA-compliant will enable data reporting, charting,
and other features requiring storage of HIPAA-controlled
personal health information.`}</p>
    <p>{`For more information, contact us at `}<a parentName="p" {...{
        "href": "mailto:compliance@openaba.com"
      }}>{`compliance@openaba.com`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;